import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
@Injectable({
    providedIn: 'root',
})
export class ExportService {

    private RESOURCE: string = 'export';

    constructor(private baseService: BaseService) {
    }

    /**
     * Calls the backend API to export samples to an Excel file.
     */
    public async exportSamples(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/samples');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'samples.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export vehicle models to an Excel file.
     */
    public async exportVehicleModels(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/vehicle-models');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'vehicle-models.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export countries to an Excel file.
     */
    public async exportCountries(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/countries');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'countries.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export languages to an Excel file.
     */
    public async exportLanguages(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/languages');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'languages.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export body types to an Excel file.
     */
    public async exportBodyTypes(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/body-types');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'body-types.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export car classes to an Excel file.
     */
    public async exportCarClasses(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/car-classes');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'car-classes.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export brands to an Excel file.
     */
    public async exportBrands(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/brands');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'brands.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export manufacturers to an Excel file.
     */
    public async exportManufacturers(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/manufacturers');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'manufacturers.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export dealerships to an Excel file.
     */
    public async exportDealerships(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/dealerships');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'dealerships.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export studios to an Excel file.
     */
    public async exportStudios(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/studios');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'studios.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    /**
     * Calls the backend API to export physical samples to an Excel file.
     */
    public async exportPhysicalSamples(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/physical-samples');

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'physical-samples.xlsx';
        link.click();

        // Clean up the object URL after the download
        URL.revokeObjectURL(link.href);
    }

    public async exportSampleTypes(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/sample-types');

        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'sample-types.xlsx';
        link.click();

        URL.revokeObjectURL(link.href);
    }

    public async exportSampleLanguages(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/sample-languages');

        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'sample-languages.xlsx';
        link.click();

        URL.revokeObjectURL(link.href);

    }

    public async exportSampleVehicleModels(): Promise<void> {
        const fileBlob: Blob = await this.baseService.getBlob(this.RESOURCE + '/sample-vehicle-models');

        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        link.download = 'sample-vehicle-models.xlsx';
        link.click();

        URL.revokeObjectURL(link.href);
    }

    public async customSampleExport(filters: {
        fieldOfUse?: string[],
        sampleType?: number[],
        sampleState?: string[],
        sampleCategory?: number[],
        sampleDetail?: number[],
        format?: string[],
        brand?: number[],
        carClass?: number[],
        bodyType?: number[],
    }, hideEmptyColumns: boolean): Promise<void> {
        const queryParams = new URLSearchParams();

        for (const [ key, value ] of Object.entries(filters)) {
            if (Array.isArray(value)) {
                value.forEach(v => queryParams.append(key, String(v)));
            }
        }

        queryParams.append('hideEmptyColumns', String(hideEmptyColumns));

        const fileBlob: Blob = await this.baseService.getBlob(
            this.RESOURCE + '/custom-samples?' + queryParams.toString()
        );

        const link = document.createElement('a');
        link.href = URL.createObjectURL(fileBlob);
        const dateStr = new Date().toLocaleDateString('de-DE');
        link.download = `custom-samples-${ dateStr }.xlsx`;
        link.click();

        URL.revokeObjectURL(link.href);
    }
}
